import React, {Fragment, Component} from 'react';
import ViewForm from './ViewForm';
import {GridColumn, Grid} from '@atlaskit/page';
import {TextField, FormSection} from '../../../components/FormFields';
import Button, { ButtonGroup } from '@atlaskit/button';
import {FormFooter} from '@atlaskit/form';
import {EditViewContext} from './EditViewContext';
import i18n from 'i18next';
import {Trans} from 'react-i18next';

export const CarCheckForm = ({car, fetching, onChange, onSubmit, onClose}) => (
  <form onSubmit={onSubmit}>
    <Grid>
      <GridColumn medium={6}>
        <TextField
          name='car.vin'
          label={i18n.t('clients:VIN')}
          placeholder={i18n.t('clients:Enter VIN')}
          required={true}
          onChange={onChange}
          isDisabled={fetching}
          value={car.vin}
        />
      </GridColumn>
      <GridColumn medium={6}>
        <TextField
          name='car.epts'
          label={i18n.t('clients:Vehicle passport')}
          placeholder={i18n.t('clients:Enter vehicle passport number')}
          required={true}
          onChange={onChange}
          isDisabled={fetching}
          value={car.epts}
        />
      </GridColumn>
      <GridColumn medium={12}>
        <FormFooter>
          <ButtonGroup>
            <Button appearance='subtle' isDisabled={fetching} onClick={onClose}>
              <Trans>
                Cancel
              </Trans>
            </Button>
            <Button type='submit' isDisabled={fetching} isLoading={fetching} appearance='danger'>
              <Trans>
                Check
              </Trans>
            </Button>
          </ButtonGroup>
        </FormFooter>
      </GridColumn>
    </Grid>
  </form>
)

export const CarFormFields = ({
  car,
  fetching,
  onChange,
  showCheckedFields = true
}) => (
  <Fragment>
    {showCheckedFields && (
      <Fragment>
        <GridColumn medium={6}>
          <TextField
            name='car.vin'
            label={i18n.t('clients:VIN')}
            placeholder={i18n.t('clients:Enter VIN')}
            required={true}
            isDisabled={true}
            value={car.vin}
          />
        </GridColumn>
        <GridColumn medium={6}>
          <TextField
            name='car.epts'
            label={i18n.t('clients:Vehicle passport')}
            placeholder={i18n.t('clients:Enter vehicle passport number')}
            required={true}
            isDisabled={true}
            value={car.epts}
          />
        </GridColumn>
      </Fragment>
    )}
    <GridColumn medium={12}>
      <FormSection>{i18n.t('clients:Vehicle')}</FormSection>
    </GridColumn>
    <GridColumn medium={6}>
      <TextField
        name='car.make'
        label={i18n.t('clients:Make')}
        placeholder={i18n.t('clients:Enter make')}
        required={true}
        onChange={onChange}
        isDisabled={fetching}
        value={car.make}
      />
    </GridColumn>
    <GridColumn medium={6}>
      <TextField
        name='car.model'
        label={i18n.t('clients:Model')}
        placeholder={i18n.t('clients:Enter model')}
        required={true}
        onChange={onChange}
        isDisabled={fetching}
        value={car.model}
      />
    </GridColumn>
    <GridColumn medium={4}>
      <TextField
        name='car.year'
        label={i18n.t('clients:Year')}
        placeholder={i18n.t('clients:Enter year')}
        required={true}
        onChange={onChange}
        isDisabled={fetching}
        value={car.year}
        type='number'
      />
    </GridColumn>
    <GridColumn medium={4}>
      <TextField
        name='car.color'
        label={i18n.t('clients:Color')}
        placeholder={i18n.t('clients:Enter color')}
        required={true}
        onChange={onChange}
        isDisabled={fetching}
        value={car.color}
      />
    </GridColumn>
    <GridColumn medium={4}>
      <TextField
        name='car.plate'
        label={i18n.t('clients:Reg plate')}
        placeholder={i18n.t('clients:Enter reg plate')}
        required={false}
        onChange={onChange}
        isDisabled={fetching}
        value={car.plate}
      />
    </GridColumn>
  </Fragment>
)

class CarAddForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      checked: false,
      car: {
        vin: '',
        epts: '',
        plate: '',
        make: '',
        model: '',
        year: '',
        color: '',
      },
    };
  }

  componentWillUnmount() {
    if (this.state.checked && this.props.edit) {
      this.props.onClose();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.fetching && prevProps.fetching !== this.props.fetching) {
      if (this.props.error) {
        //произошла ошибка
        if (this.props.car) {
          // во время сохранения

        } else {
          // во время проверки

        }
      } else if (this.state.checked) {
        // Сохранение завершилось
        this.props.onClose();
      } else if (this.props.car && this.props.car.vin && this.props.car.epts) {
        // Проверка прошла, пришли данные с проверки
        this.setState({
          car: {...this.state.car, ...this.props.car},
          checked: true,
        });
      }
    }
  }

  onCheckFormSubmit = e => {
    e.preventDefault();
    this.props.onCheckCar(this.state.car.vin, this.state.car.epts);
  }

  onFormSubmit = e => {
    e.preventDefault();
    this.props.onAdd(this.props.client.id, this.state.car);
  }

  onChange = (name, value) => {
    
    let fieldName = name;
    if (name.includes('.')) {
      const path = name.split('.');
      if (path.length === 2) {
        fieldName = path[1];
      }
    }

    this.setState({
      car: {...this.state.car, [fieldName]: value},
    });
  }

  render() {
    const {onClose, fetching} = this.props;
    const {checked, car} = this.state;

    return (
      <GridColumn medium={12}>
        {checked ? (
          <form onSubmit={this.onFormSubmit}>
            <Grid>
              <CarFormFields 
                car={car}
                onChange={this.onChange}
                fetching={fetching}
              />
              <GridColumn medium={12}>
                <FormFooter>
                  <ButtonGroup>
                    <Button appearance='subtle' isDisabled={fetching} onClick={onClose}>
                      <Trans>
                        Cancel
                      </Trans>
                    </Button>
                    <Button type='submit' isDisabled={fetching} isLoading={fetching} appearance='danger'>
                      <Trans>
                        Add
                      </Trans>
                    </Button>
                  </ButtonGroup>
                </FormFooter>
              </GridColumn>
            </Grid>
           </form>
        ) : (
          <CarCheckForm
            car={car}
            onChange={this.onChange}
            fetching={fetching}
            onSubmit={this.onCheckFormSubmit}
            onClose={onClose}
          />
      )}
      </GridColumn>
    )
  }
}


export default props => {
  const formName = 'сar';

  return (
    <EditViewContext.Consumer>
      {({edit, onChangeEditMode, onChange}) => (
        <ViewForm
          formName={formName}
          title={i18n.t('clients:Add vehicle')}
          editMode={true}
        >
          <CarAddForm {...props} edit={edit===formName} onClose={onChangeEditMode(null)} />
        </ViewForm>
      )}
    </EditViewContext.Consumer>
  );
}
